import React, { useState, useRef } from 'react';
import PropertyDetails from './PropertyDetails';
import EditProperty from './EditProperty';

import { useDispatch } from 'react-redux';
import { deleteProperty, fetchAllProperties } from '../../redux/actions/propertyActions';


const PropertyList = ({
  properties,
  onFilter,
  provinces = [],
  pagination,
  page,
  setPage,
  loading = false
}) => {

  const [selectedProperty, setSelectedProperty] = useState(null);
  const [search, setSearch] = useState("");
  const [provinceFilter, setProvinceFilter] = useState("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);

  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  

  const dispatch = useDispatch();

  const propertyArray = Array.isArray(properties) ? properties : [];

  const handleViewDetails = (property) => {
    setSelectedProperty(property);
    setViewModal(true);
  };


  // Handle search and filter
  // Debounce search for better UX
  const debounceTimeout = useRef();
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      const filter = {};
      if (value) filter.q = value;
      if (provinceFilter) filter.province_id = provinceFilter;
      onFilter(filter);
    }, 350);
  };
  const handleProvinceChange = (e) => {
    const value = e.target.value;
    setProvinceFilter(value);
    if (!value) {
      // If 'All Provinces' is selected, remove province_id from filter
      const filter = {};
      if (search) filter.q = search;
      onFilter(filter);
    } else {
      const filter = { province_id: value };
      if (search) filter.q = search;
      onFilter(filter);
    }
  };


  const handleEdit = (property) => {
    setSelectedProperty(property);
    setEditModal(true);
  };


  const handleCloseModal = () => {
    setViewModal(false);
    setEditModal(false);
    setSelectedProperty(null);
  };


  const handleDeleteClick = (property) => {
    setPropertyToDelete(property);
    setShowDeleteModal(true);
  };


  const confirmDelete = async () => {
    if (!propertyToDelete) return;

    const res = await dispatch(deleteProperty(propertyToDelete.id));
    if (res.meta.requestStatus === 'fulfilled') {
      // toast.success('Property deleted successfully!');
      await dispatch(fetchAllProperties({ page, limit: 10 }));
      setShowDeleteModal(false);
      setPropertyToDelete(null);
    } else {
      const msg = res.payload?.message;
      if (msg === "Property has an active lease. Please deactivate or end the lease first.") {
        setShowDeleteModal(false);
        setPropertyToDelete(null);
      }
    }
  };



  return (
    <div className="container py-4">
      {/* <div className="row mb-3">
        <div className="col-12">
          <h2 className="display-6 text-center mb-2">Property Listing</h2>
          <p className="text-center text-muted">All managed properties and their details</p>
        </div>
      </div> */}

      {/* FILTERS */}
      <div className="row mb-3 g-2">

        <div className="col-md-3">
          <select
            className="form-select"
            value={provinceFilter}
            onChange={handleProvinceChange}
          >
            <option value="">All Provinces</option>
            {provinces?.map((prov) => (
              <option key={prov.id} value={prov.id}>{prov.name}</option>
            ))}
          </select>
        </div>
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search by property name, street number, street name, city, postal code..."
            value={search}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <div className="row g-4">
        <table className="table table-striped table-hover align-middle">
          <thead className="table-primary">
            <tr>
              <th>Property Name</th>
              <th>Province</th>
              <th>Street Number</th>
              <th>Street Name</th>
              <th>Landlord</th>
              <th>Tenants</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  Loading properties...
                </td>
              </tr>
            )}

            {!loading && propertyArray.length === 0 && (
              <tr>
                <td colSpan="7" className="text-center py-4 text-muted">
                  No properties found
                </td>
              </tr>
            )}

            {!loading && propertyArray.map((property) => (

              <tr key={property.id}>
                <td><strong>{property.property_name}</strong></td>
                <td>{property.province && property.province.name ? property.province.name : '-'}</td>
                <td>{property.street_number || '-'}</td>
                <td>{property.street_name || '-'}</td>
                <td>{property.landlord ? `${property.landlord.first_name} ${property.landlord.last_name}` : '-'}</td>
                {/* <td>
                  {property.tenants && property.tenants.length > 0
                    ? property.tenants.map((tenant) => tenant.full_name).join(', ')
                    : '-'}
                </td> */}
                <td>
  {property.tenants && property.tenants.length > 0
    ? property.tenants
        .map((t) =>
          t.tenant
            ? `${t.tenant.first_name || ""} ${t.tenant.last_name || ""}`.trim()
            : "-"
        )
        .join(", ")
    : "-"}
</td>


                <td>
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-sm btn-info me-2 text-white"
                      onClick={() => handleViewDetails(property)}
                    >
                      <i className="bi bi-eye"></i> View
                    </button>

                    <button
                      className="btn btn-sm btn-warning me-2 text-white"
                      onClick={() => handleEdit(property)}
                    >
                      <i className="bi bi-pencil"></i> Edit
                    </button>
                    <button
                      className="btn btn-sm btn-danger text-white"
                      onClick={() => handleDeleteClick(property)}
                    >
                      <i className="bi bi-trash"></i> Delete
                    </button>

                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      {pagination?.totalPages > 1 && (
        <div className="d-flex justify-content-center gap-2 mt-3">
          <button
            className="btn btn-outline-primary btn-sm"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          <span className="align-self-center">
            Page {page} of {pagination.totalPages}
          </span>

          <button
            className="btn btn-outline-primary btn-sm"
            disabled={page === pagination.totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}


      {/* Modal */}

      {/* VIEW MODAL */}
      {viewModal && selectedProperty && (
        <PropertyDetails
          selectedProperty={selectedProperty}
          handleCloseModal={handleCloseModal}
        />
      )}

      {/* EDIT MODAL */}
      {editModal && selectedProperty && (
        <EditProperty
          selectedProperty={selectedProperty}
          handleCloseModal={handleCloseModal}
        />
      )}


      {showDeleteModal && propertyToDelete && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">

                <div className="modal-header bg-danger text-white">
                  <h5 className="modal-title">Delete Property</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowDeleteModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <p>
                    Are you sure you want to delete
                    <strong> {propertyToDelete.property_name}</strong>?
                  </p>
                  <p className="text-muted mb-0">
                    This property will be deleted permanently .
                  </p>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={confirmDelete}
                  >
                    Delete
                  </button>
                </div>

              </div>
            </div>
          </div>

          {/* Backdrop */}
          {/* <div className="modal-backdrop fade show" /> */}
        </>
      )}



      <style jsx>{`
        .modal.show {
          background-color: rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </div>
  );
};

export default PropertyList;
